import { Users, Activity, Image, FileText, TrendingUp } from 'lucide-react';

export const KPITicker = ({ kpis }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
    <div className="kpi-card p-6 rounded-lg" data-testid="kpi-total-users">
      <div className="flex items-center justify-between mb-3">
        <Users className="w-8 h-8 text-[#00ff41]" />
        <TrendingUp className="w-5 h-5 text-[#00ff41] opacity-60" />
      </div>
      <p className="text-gray-400 text-sm uppercase tracking-wide">Total Users</p>
      <p className="text-3xl font-bold text-[#00ff41] mt-2">{kpis.totalUsers.toLocaleString()}</p>
    </div>
    <div className="kpi-card p-6 rounded-lg" data-testid="kpi-dau">
      <div className="flex items-center justify-between mb-3">
        <Activity className="w-8 h-8 text-[#00d1ff]" />
        <TrendingUp className="w-5 h-5 text-[#00d1ff] opacity-60" />
      </div>
      <p className="text-gray-400 text-sm uppercase tracking-wide">DAU (24h)</p>
      <p className="text-3xl font-bold text-[#00d1ff] mt-2">{kpis.dau.toLocaleString()}</p>
      <p className="text-xs text-gray-500 mt-1">Field not tracked</p>
    </div>
    <div className="kpi-card p-6 rounded-lg" data-testid="kpi-total-photos">
      <div className="flex items-center justify-between mb-3">
        <Image className="w-8 h-8 text-[#00ff41]" />
        <TrendingUp className="w-5 h-5 text-[#00ff41] opacity-60" />
      </div>
      <p className="text-gray-400 text-sm uppercase tracking-wide">Total Photos</p>
      <p className="text-3xl font-bold text-[#00ff41] mt-2">{kpis.totalPhotos.toLocaleString()}</p>
    </div>
    <div className="kpi-card p-6 rounded-lg" data-testid="kpi-total-quiz-answers">
      <div className="flex items-center justify-between mb-3">
        <FileText className="w-8 h-8 text-[#00d1ff]" />
        <TrendingUp className="w-5 h-5 text-[#00d1ff] opacity-60" />
      </div>
      <p className="text-gray-400 text-sm uppercase tracking-wide">Quiz Answers</p>
      <p className="text-3xl font-bold text-[#00d1ff] mt-2">{kpis.totalQuizAnswers.toLocaleString()}</p>
    </div>
  </div>
);
